import { withFormik } from 'formik';
import { connect } from 'react-redux';
import { sendEmail } from '../../../slices/authSlice';
import { ForgotPasswordForm } from './ForgotPasswordForm';
import * as Yup from 'yup';

//constants
import {
  EMAIL_INVALID_ERROR,
  EMAIL_NOT_LONG_ERROR,
  EMAIL_REQUIRED,
} from '../../../constants/messages/formMessages';

const EnhancedForgotPasswordForm = withFormik({
  mapPropsToValues: () => ({
    email: '',
  }),
  validationSchema: Yup.object().shape({
    email: Yup.string()
      .min(3, EMAIL_NOT_LONG_ERROR)
      .max(255)
      .email(EMAIL_INVALID_ERROR)
      .required(EMAIL_REQUIRED),
  }),
  handleSubmit: (values, { props, setSubmitting }) => {
    const { sendEmail, setOpenModal } = props;
    sendEmail(values.email);
    console.log(values);
    setOpenModal(false);
    setSubmitting(false);
  },
  displayName: 'ForgotPasswordForm',
})(ForgotPasswordForm);

export default connect(null, { sendEmail })(EnhancedForgotPasswordForm);
